module.exports = __webpack_public_path__ + "static/media/send.594b3cb1.svg";